export enum RouterReference {
  R23319 = "R23319", // Xiaomi
  R2640 = "R2640", // LEGACY
  R4230G = "R4230G", // LEGACY
  DIR_2640 = "DIR_2640", // Dlink
  Archer_C6 = "Archer_C6", // TP-Link
  EAP225_Outdoor = "EAP225_Outdoor", // TP-Link
  EAP225 = "EAP225", // TP-Link
  EAP610 = "EAP610", // TP-Link
  EAP115 = "EAP115", // TP-Link 
  C9105AXW_I = "C9105AXW_I",
  FortiAP_231G = "FortiAP_231G"
}

export const RouterReferenceEnumMapping: Record<RouterReference, string> = {
    [RouterReference.R23319]: "R23319", // Xiaomi
    [RouterReference.R2640]: "R2640", // LEGACY
    [RouterReference.R4230G]: "R4230G", // LEGACY
    [RouterReference.DIR_2640]: "DIR-2640", // Dlink
    [RouterReference.Archer_C6]: "Archer-C6", // TP-Link
    [RouterReference.EAP225_Outdoor]: "EAP225-Outdoor", // TP-Link
    [RouterReference.EAP225]: "EAP225", // TP-Link
    [RouterReference.EAP610]: "EAP610", // TP-Link
    [RouterReference.EAP115]: "EAP115", // TP-Link 
    [RouterReference.C9105AXW_I]: "C9105AXW-I", //cisco-catalyst
    [RouterReference.FortiAP_231G]: "FortiAP 231G" // Fortinet
  };

export interface RouterReferenceInterface {
  id: RouterReference;
  value: string;
}
